import { ApplicationState } from '../../../../store/types';
import { getWorkflowRoot } from '../../store/selectors';
import { ScheduleEventTab, Scheduler, SchedulerDB, CalendarEvent, WorkflowPage, ScheduledActionsListView } from './types';

export const getWorkflowPage = (state: ApplicationState): WorkflowPage => getWorkflowRoot(state).workflowPage;

export const getCalendarWizardOpen = (state: ApplicationState): boolean => getWorkflowRoot(state).calendarWizardOpen;

export const getCalendarEvent = (state: ApplicationState): Scheduler => getWorkflowRoot(state).event;

export const getToolbarDate = (state: ApplicationState): Date => getWorkflowRoot(state).toolbarDate;

export const getIsEditing = (state: ApplicationState): boolean => getWorkflowRoot(state).isEditing;

export const getScheduledActionUpdated = (state: ApplicationState): boolean => getWorkflowRoot(state).showUpdatedMessage;

export const getSelectedMonthYear = (state: ApplicationState): string => getWorkflowRoot(state).selectedMonthYear;

export const getSelectedEventTab = (state: ApplicationState): ScheduleEventTab => getWorkflowRoot(state).selectedEventTab;

export const getSelectedEventTabValid = (state: ApplicationState): boolean => getWorkflowRoot(state).selectedTabValid;

export const getScheduledDetailsConfirmed = (state: ApplicationState): boolean => getWorkflowRoot(state).scheduleDetailsCorrect;

export const getIsSavingScheduledAction = (state: ApplicationState): boolean => getWorkflowRoot(state).isSaving;

export const getAllScheduledActions = (state: ApplicationState): SchedulerDB[] => getWorkflowRoot(state).scheduledActions;

export const getScheduledEvents = (state: ApplicationState): CalendarEvent[] => getWorkflowRoot(state).selectedMonthActions;

export const getConfirmDeleteEvent = (state: ApplicationState): number | null => getWorkflowRoot(state).confirmDeleteEvent;

export const getIsDeleting = (state: ApplicationState): boolean => getWorkflowRoot(state).isDeleting;

export const getScheduledActionsListView = (state: ApplicationState): ScheduledActionsListView => getWorkflowRoot(state).scheduledActionsListView;

export const getIsLoading = (state: ApplicationState): boolean => getWorkflowRoot(state).isLoading;

export const getSelectedEventDate = (state: ApplicationState): string | null => getWorkflowRoot(state).selectedEventDate;
